import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AiReviseEmailInput, AiStatus, AiWriteEmailInput, EmailBlock } from '@crm/shared';
import { api } from '../../api/client';

export interface AiEmailResult {
  subject: string;
  preheader: string;
  blocks: EmailBlock[];
  model: string;
}

const KEY = ['ai-status'];

export const useAiStatus = () => useQuery({ queryKey: KEY, queryFn: async () => (await api.get<AiStatus>('/ai/status')).data, staleTime: 5 * 60_000 });

export function useSaveAiSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { defaultModel: string | null }) => (await api.put<AiStatus>('/ai/settings', input)).data,
    onSuccess: (data) => qc.setQueryData(KEY, data),
  });
}

export const useAiWrite = () => useMutation({ mutationFn: async (input: AiWriteEmailInput) => (await api.post<AiEmailResult>('/ai/email/write', input)).data });
export const useAiRevise = () => useMutation({ mutationFn: async (input: AiReviseEmailInput) => (await api.post<AiEmailResult>('/ai/email/revise', input)).data });
